import { PURGE } from 'redux-persist';
import initialState from './InitialState';
import TYPES from '../../../@types/redux/store/ServiceTypes';
import { ServiceAction, ServiceState } from '../../../@types';

export default (
  state: ServiceState = initialState,
  action: ServiceAction
): ServiceState => {
  switch (action.type) {
    case TYPES.SET_SERVICES: {
      return action.payload.services;
    }
    // @ts-ignore
    case PURGE:
      return initialState;

    default: {
      action as never; // eslint-disable-line no-unused-expressions

      return state;
    }
  }
};
